import request from '@/lib/request'
import env from '@/utils/env'

// 事件统计
export default function event(eventName, eventData) {
  const data = {}
  if (eventName == 'pageview') {
    Object.assign(
      data,
      {
        bizsys: 'h5',
        eventType: 'pageview',
        eventId: 'webapp', // 默认使用项目名称
      },
      eventData,
    )
  } else {
    Object.assign(
      data,
      {
        bizsys: 'hbyy',
        eventType: eventName,
      },
      eventData,
    )
  }

  return eventApi(data)
}

function eventApi(opts) {
  return request.gateway({
    url: '/gateway/hldm/trace',
    method: 'GET',
    sidFields: ['pid', 'p', 'systemtime'],
    data: {
      pid: 651002,
      p: opts.p || getParamP(),
      ...opts,
    },
  })
}

function getParamP() {
  const source = env.hlsource || 'webapp'
  const client = 'webapp'
  const cver = process.env.VUE_APP_API_CVER
  return [source, env.os, client, cver, 'web'].join(',')
}
